<div class="search-bar">
  <div class="container container-size-sm search-bar__inner">
    <form class="search-bar__form" [formGroup]="searchForm" (ngSubmit)="onSearch()">
      <app-icon
        [anchor]="(searchResultsLoading$ | async) === true ? 'icon-loader' : 'icon-search'"
        [class.anim--spinning]="(searchResultsLoading$ | async) === true"
      ></app-icon>
      <input #input formControlName="q" type="text" (keydown.enter)="toOverview()" [placeholder]="'zoeken-placeholder' | fromDictionary" />
      @if (hasValue) {
        <button class="button button-icon button--secondary button--xs" (click)="closeSearch()" aria-label="Zoekbalk sluiten">
          <app-icon anchor="icon-close-xs"></app-icon>
        </button>
      }
    </form>
  </div>
</div>
